import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Redirect www to non-www (SEO best practice)
if (window.location.hostname === 'www.spedireonline.net') {
  window.location.replace('https://spedireonline.net' + window.location.pathname + window.location.search);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
